import {axiosInstance} from './api';

const GOOGLE_API_KEY_ENDPOINT = 'maps/g_api_key';

export default class KeysApi {
    static getGoogleApiKey() {
        return axiosInstance.get(GOOGLE_API_KEY_ENDPOINT);
    }
}